const useRole = () => {
  const drawerMenu = [];

  return {
    drawerMenu,
  };
};

export default useRole;
